import { PumpTimelineMessages, TranslationPumpTimelineMessages } from "../interfaces";

export const messages: TranslationPumpTimelineMessages = {
  [PumpTimelineMessages.state]: "State",
  [PumpTimelineMessages.destination]: "Destination",
  [PumpTimelineMessages.driver]: "Driver",
  [PumpTimelineMessages.tooltipSpeedThreshold]: "Maximum speed: ",
  [PumpTimelineMessages.tooltipGenerateAt]: "Generated"
};
